import resourcesToBackend from 'i18next-resources-to-backend';

import { lazyTranslationsRegistry } from '../registerLazyTranslations';

const lazyBackend = resourcesToBackend(async (lng: string, ns: string) => {
  const loader = lazyTranslationsRegistry.get(ns);

  if (!loader) {
    throw new Error(
      `i18n: no lazy loader registered for namespace "${ns}". Did you forget to import the module's i18n/index.ts, or is this namespace meant to be bundled eagerly via addTranslations?`,
    );
  }

  try {
    return await loader(lng);
  } catch (err) {
    console.warn(
      `i18n: failed to load translations for namespace "${ns}" (${lng})`,
      err,
    );
    return {};
  }
});

export default lazyBackend;
